import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { undashifyAndCapitalise } from "@cinch-labs/shared-util";
import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { tagError, setTag, traceFunction } from "@core/datadog-server";
var instrumentedGetStoryBySlug = traceFunction("getStoryBySlug", getStoryBySlug);
export var getStaticPropsGenerator = function(param) {
    var path = param.path, resolveRelations = param.resolveRelations, passedBreadCrumbs = param.passedBreadCrumbs, shouldUndashifyAndCapitalise = param.shouldUndashifyAndCapitalise;
    return function() {
        var _ref = _async_to_generator(function(param) {
            var params, _preview, preview, slug, story, breadCrumbs, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = param.params, _preview = param.preview, preview = _preview === void 0 ? false : _preview;
                        slug = params === null || params === void 0 ? void 0 : params.slug;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            instrumentedGetStoryBySlug("".concat(path, "/").concat(slug), {
                                version: preview ? "draft" : "published",
                                resolve_relations: resolveRelations
                            })
                        ];
                    case 2:
                        story = _state.sent();
                        breadCrumbs = _to_consumable_array(passedBreadCrumbs).concat([
                            shouldUndashifyAndCapitalise && {
                                text: undashifyAndCapitalise(slug),
                                url: "/".concat(path, "/").concat(slug)
                            }
                        ]);
                        return [
                            2,
                            {
                                props: {
                                    story: story,
                                    preview: preview,
                                    layoutProps: {
                                        showBorderRadius: true,
                                        breadCrumbs: breadCrumbs
                                    }
                                },
                                revalidate: 60
                            }
                        ];
                    case 3:
                        error = _state.sent();
                        if (typeof error === "string" || _instanceof(error, Error)) {
                            tagError(error);
                        }
                        setTag("response.statusCode", 404);
                        console.log(error);
                        return [
                            2,
                            {
                                notFound: true,
                                props: {
                                    story: null,
                                    preview: preview,
                                    layoutProps: {
                                        showBorderRadius: true,
                                        breadCrumbs: []
                                    }
                                },
                                revalidate: 60
                            }
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};
